import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import RefreshButton from '../../../components/RefreshButton';
import TableFooter from '../../../components/TableFooter';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';
import { Helpers } from '../../../helpers/Helpers';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import { GetEscalationListPagingAndFilterRequest, initialGetEscalationListPagingAndFilterRequest } from '../../../models/request/escalation/GetEscalationListPagingAndFilterRequest';
import {
    DeleteEscalationResponse,
    ExportEscalationListResponse,
    GetEscalationCostItemColumnsResponse,
    GetEscalationListPagingAndFilterResponse,
    GetEscalationListPagingAndFilterResponseData,
    GetEscalationListPagingAndFilterResponseItem,
    initialGetEscalationListPagingAndFilterResponseData
} from '../../../models/response/escalation/GetEscalationListPagingAndFilterResponse';
import { storeActivityIndicator } from '../../../redux/reducers/authSlice';
import { RootState } from '../../../redux/store';
import { EscalationService } from '../../../services/EscalationService';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import EscalationListFilters from './Components/EscalationListFilters';

/** Maliyet kalemi kolonlarinin adi bu onekle gelir ("dynamic Yakıt"). */
const DYNAMIC_PREFIX = 'dynamic ';

const EscalationList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)

    const pageName = "Ayarlar > Eskalasyon Dağılımı"
    const pageVersion = "1";

    const [data, setData] = useState<GetEscalationListPagingAndFilterResponseData>(initialGetEscalationListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetEscalationListPagingAndFilterRequest>(initialGetEscalationListPagingAndFilterRequest)

    /** Sabit kolonlar. Maliyet kalemi kolonlari bunlarin arasina sonradan eklenir. */
    const sabitKolonlar = (): ColumnChooserModel[] => ([
        { title: 'Dönem', name: 'periodStr', order: 0, isVisible: true },
        { title: 'İşlem Tarihi', name: 'transactionDateStr', order: 0, isVisible: true },
        { title: 'Toplam (%)', name: 'totalValue', order: 0, isVisible: true, className: 'custom-text-right' },
        { title: 'Açıklama', name: 'description', order: 0, isVisible: true },
        { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
        { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
    ]);

    const getColumns = () => {
        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        var list = sabitKolonlar();

        for (var i = 0; i < list.length; i++)
            list[i].order = i + 1;

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    /**
     * Maliyet kalemi kolonlari sunucudan gelir (yalniz kullanilmis olanlar).
     * Kullanicinin kolon secicideki tercihleri korunur: daha once gordugu kolonun
     * gorunurlugu ve sirasi degismez, yeni kalem sona eklenir, artik kullanilmayan
     * kalem listeden dusurulur.
     */
    const kolonlariTazele = async () => {
        try {
            var response: GetEscalationCostItemColumnsResponse = await EscalationService.getEscalationCostItemColumns();

            if (!response.isSuccess)
                return;

            var kalemler = response.data ?? [];

            setColumns(function (mevcut) {
                var sabitAdlar = sabitKolonlar().map(x => x.name);

                // Kullanicinin tercihleri (gorunurluk/sira) ada gore korunur.
                var korunan = mevcut.filter(x => sabitAdlar.includes(x.name)
                    || kalemler.some(k => DYNAMIC_PREFIX + k.name == x.name));

                var eksikler = kalemler
                    .filter(k => !korunan.some(x => x.name == DYNAMIC_PREFIX + k.name))
                    .map(function (k): ColumnChooserModel {
                        return {
                            title: k.name + ' (%)',
                            name: DYNAMIC_PREFIX + k.name,
                            order: 0,
                            isVisible: true,
                            className: 'custom-text-right'
                        }
                    });

                // Eksik sabit kolon varsa (surum atlanmis olabilir) o da eklenir.
                var eksikSabitler = sabitKolonlar().filter(x => !korunan.some(y => y.name == x.name));

                var sonuc = [...korunan, ...eksikler, ...eksikSabitler];

                for (var i = 0; i < sonuc.length; i++)
                    if (!sonuc[i].order)
                        sonuc[i].order = i + 1;

                return sonuc;
            });
        } catch {
            // Kolonlar gelmezse liste sabit kolonlarla calismaya devam eder.
        }
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        kolonlariTazele();
        getData();
    }, [])

    const performPagination = (i: number) => {
        getData({ ...filter, currentPage: i, skip: (i - 1) * filter.take });
    }

    const changeTake = (_take: number) => {
        getData({ ...filter, currentPage: 1, skip: 0, take: _take });
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetEscalationListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response: GetEscalationListPagingAndFilterResponse = await EscalationService.getEscalationListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const deleteEscalation = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.escalationId);

            dispatch(storeActivityIndicator(true))

            var response: DeleteEscalationResponse = await EscalationService.deleteEscalation(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            // Silinen kaydin kalemleri artik kullanilmiyor olabilir; kolonlar yenilenir.
            kolonlariTazele();
            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateEscalation = async (_id: string | undefined = undefined) => {
        navigate('/escalation/listadd?id=' + (_id ? _id : data.items.filter(x => x.isSelected)[0].escalationId));
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.escalationId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.length == data.items.filter(x => x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                x.isSelected = !isAllSelected;
                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportEscalationListResponse = await EscalationService.exportEscalationList(
                buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.escalationId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Maliyet kalemi kolonlari da baslıktan siralanabilir.
    const sortableColumns = [
        'periodStr', 'transactionDateStr', 'totalValue', 'description',
        ...columns.filter(x => x.name.startsWith(DYNAMIC_PREFIX)).map(x => x.name)
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon adlari backend'deki eslemeyle (EscalationManager) ayni.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        periodStr: { type: 'number' },
        transactionDateStr: { type: 'date' },
        totalValue: { type: 'number' },
        description: { type: 'text' },
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Maliyet kalemi kolonlari sayisal suzgec alir (deger araligi).
    columns.filter(x => x.name.startsWith(DYNAMIC_PREFIX)).forEach(function (x) {
        columnFilterDefinitions[x.name] = { type: 'number' };
    });

    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetEscalationListPagingAndFilterResponseItem, column: string, className: string | undefined) => {
        const tikla = { onClick: () => setItemSelected(item.escalationId), onDoubleClick: () => updateEscalation(item.escalationId) };

        if (column.startsWith(DYNAMIC_PREFIX)) {
            var kalemAdi = column.substring(DYNAMIC_PREFIX.length);
            var satir = (item.items ?? []).find(x => x.costItemName == kalemAdi);

            // Kalemi girilmemis kayitta hucre bos kalir.
            return <td className={className} {...tikla}>{satir ? Helpers.correctPrice(satir.value, 2) : ''}</td>;
        }

        if (column == "createdUser")
            return <td className={className} {...tikla}>{item.createdUser} - {item.createdDate}</td>;

        if (column == "updatedUser")
            return <td className={className} {...tikla}>{item.updatedUser} - {item.updatedDate}</td>;

        if (column == "totalValue")
            return <td className={className} {...tikla}>{Helpers.correctPrice(item.totalValue, 2)}</td>;

        var item2: any = item;
        return <td className={className} {...tikla}>{item2[column]}</td>;
    }

    const gorunenKolonlar = columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; });

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => { kolonlariTazele(); getData(); }} />
                <EscalationListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    setFilter={setFilter}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    deleteFunction={deleteEscalation}
                    updateFunction={updateEscalation}
                    onSearchSubmit={onSearchSubmit}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            gorunenKolonlar.map((item) =>
                                                <th key={item.name} {...thProps(item.name)}>{item.title}{sortArrow(item.name)}</th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={gorunenKolonlar}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item) =>
                                            <tr key={item.escalationId} style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                            <input onChange={() => setItemSelected(item.escalationId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                        </label>
                                                    </div>
                                                </td>

                                                {
                                                    gorunenKolonlar.map((column) => (
                                                        <React.Fragment key={column.name}>{getColumnValue(item, column.name, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default EscalationList;
